import { HostListener, Injectable } from '@angular/core';

@Injectable()
export class KeyboardService {
    static activeElement: any;
    static isKeyEventBinded: Boolean = false;
    static isIE: boolean;
    static isFireFox: boolean;
    static isTouch: boolean;
    static isIPad: boolean;
    static isIPhone: boolean;
    static isIPod: boolean;
    static isAndroid: boolean;

    /** keyCode - stores charcode information.
     * @param  {number array} navigationKeys - left, top, right, bottom keys.
     * @param  {number array} systemKeys - shift, control and alt key.
     * @param  {number array} manipulationKeys - backspace, tab, end, home and delete.
     * @param  {number array} numberKeys - between 0 to 9.
     */
    keyCode = { systemKeys: [16, 17, 18], manipulationKeys: [8, 9], numberKeys: [48, 49, 50, 51, 52, 53, 54, 55, 56, 57] };

    constructor() {
        if (KeyboardService.isKeyEventBinded === false) {
            const self = this;
            KeyboardService.isKeyEventBinded = true;
            document.addEventListener('keydown', function (event) { self.handleKeyboardEvent(event); });
        }
    }
    /** validateInput - checks if char typed is number.
     * @param  {string} key - key which is pressed.
     * @param  {number} charcode - charcode of the key which is pressed.
     * @param  {boolean} shift -true if shift is pressed.
     * @param  {boolean} alt - true if alt is pressed.
     * @param  {boolean} ctrl - true if ctrl is pressed.
     * @param  {InputType} inputtype - type of input i.e. number ot text
     * @returns boolean
     */
    validateInput(key: string, charcode: number, shift: boolean, alt: boolean, ctrl: boolean, inputtype: InputType): boolean {

        let result = true;

        switch (inputtype) {

            case InputType.number:
                {
                    result = false;

                    if (this.checkForKeys(key, charcode, shift, alt, ctrl) || this.keyCode.numberKeys.indexOf(charcode) !== -1) {
                        result = true;
                    }
                }
                break;

            default:
                break;
        }
        return result;

    }
    /** validateBasicInput - checks if key pressed provides basic functionalities of keyboard.
     * @param  {string} key - key which is pressed.
     * @param  {number} charcode - charcode of the key which is pressed.
     * @param  {boolean} shift -true if shift is pressed.
     * @param  {boolean} alt - true if alt is pressed.
     * @param  {boolean} ctrl - true if ctrl is pressed.
     * @returns boolean
     */
    checkForKeys(key: string, charcode: number, shift: boolean, alt: boolean, ctrl: boolean): boolean {
        if (this.keyCode.systemKeys.indexOf(charcode) !== -1 || this.keyCode.manipulationKeys.indexOf(charcode) !== -1) {
            return true;
        }

        return false;
    }
    handleKeyboardEvent(event: KeyboardEvent) {
        const x: number = event.keyCode;
        const ele: any = event.target;

        if (x === KeyCodes.enter) {
            if (KeyboardService.activeElement) {
                KeyboardService.activeElement.click();
                event.preventDefault();
            }

        }
    }

}

export enum InputType {
    text = 0,
    number = 1
}

export enum KeyCodes {
    enter = 13,
    space = 32
}



// WEBPACK FOOTER //
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/src/app/core/services/keyboard.service.ts